import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import VueToastr2 from 'vue-toastr-2';
import 'vue-toastr-2/dist/vue-toastr-2.min.css';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import VModal from 'vue-js-modal'
import VueProgressBar from 'vue-progressbar'

Vue.use(VModal,{dynamic: true})
Vue.use(Vuetify) 
window.toastr = require('toastr');
 
const options = {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '12px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 3000
  },
}
Vue.use(VueProgressBar, options)
Vue.use(VueToastr2);
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.use(VueMaterial);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
